import Vue from 'vue';
import Router from 'vue-router';

const LegacyTask = () => import('@/tasks/components/LegacyTask.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'Inertia Legacy Task',
      path: '/inertia/task',
      component: LegacyTask,
    },
  ],
});

export default router;
